export default "__VITE_ASSET__CCQE7OOI__"